import 'bootstrap/dist/css/bootstrap.min.css'
import '@/styles/main.scss'
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/bellefair/400.css'
import '@fontsource/covered-by-your-grace/400.css'
import { ClerkProvider, useAuth } from '@clerk/clerk-react'
import { ConvexProvider } from 'convex/react'
import { ConvexProviderWithClerk } from 'convex/react-clerk'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { RouterProvider } from 'react-router-dom'
import Cursor from './components/Cursor'
import { initializeGoogleAnalytics } from './components/_helpers'
import SmoothScrollProvider from './components/SmoothScrollProvider'
import { PlaylistProvider } from './contexts/PlaylistContext'
import { clerkPublishableKey, getConvexClient } from './lib/convex'
import { router } from './router'
import { purgeLegacyApiStorage } from './utils/apiCache'
import { initInstallPrompt } from './lib/installPrompt'

purgeLegacyApiStorage()
// Before React: the browser offers the install event once, early.
initInstallPrompt()
initializeGoogleAnalytics()

const convexClient = getConvexClient()

function BackendProviders({ children }: { children: React.ReactNode }) {
  if (!convexClient) return <>{children}</>
  if (clerkPublishableKey) {
    return (
      <ClerkProvider publishableKey={clerkPublishableKey} afterSignOutUrl="/admin">
        <ConvexProviderWithClerk client={convexClient} useAuth={useAuth}>
          {children}
        </ConvexProviderWithClerk>
      </ClerkProvider>
    )
  }
  return <ConvexProvider client={convexClient}>{children}</ConvexProvider>
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BackendProviders>
        <SmoothScrollProvider>
          <PlaylistProvider>
            <RouterProvider router={router} />
            <Cursor />
          </PlaylistProvider>
        </SmoothScrollProvider>
      </BackendProviders>
    </HelmetProvider>
  </React.StrictMode>,
)
